// cherry-pick lodash methods
import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ActionType } from './ActionType.enum';
import { BadgeItem } from './BadgeItem.component';
import { BadgeItem as BadgeItemPropTypes } from './BadgeItem.proptypes';
import { GroupItem } from './GroupItem.component';
import { ItemType } from './ItemType.enum';
import { SearchItem } from './SearchItem.component';

export class MenuPanel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// menu  items
			items: isArray(props.items) ? props.items : [],

			// search input
			term: '',

			// search result component
			showResult: false,

			// search result count
			resultCount: 0,
		};
	}

	componentDidUpdate(prevProps) {
		const { items, showResult = false, resultCount } = this.props;
		const nextState = {};

		if (isArray(prevProps.items) && prevProps.items !== items) {
			nextState.items = items;
		}

		if (
			isBoolean(prevProps.showResult) &&
			prevProps.showResult !== showResult
		) {
			nextState.showResult = showResult;

			if (showResult === false) {
				// wipe out search input when hiding "Search Results" item
				nextState.term = '';
			}
		}

		if (prevProps.resultCount !== resultCount) {
			nextState.resultCount = resultCount;
		}

		if (!isEmpty(nextState)) {
			this.updateView(nextState);
		}
	}

	groupHeaderClickHandler = ({ groupId }) => {
		const { items } = this.state;
		const menuItems = map(items, item => ({
			...item,

			// toggle group header state
			collapsed: item.id === groupId ? !item.collapsed : item.collapsed,
		}));

		this.updateView({
			items: menuItems,
		});
	};

	actionHandler = (actionType, itemType, data) => {
		const { onActionTrigger } = this.props;
		const { term } = this.state;

		if (itemType === ItemType.Search) {
			if (actionType === ActionType.Delete) {
				// when user hits 'X' to clear search
				this.setState({ showResult: false, term: '' }, () => {
					onActionTrigger(actionType, itemType, { ...data, term: '' });
				});
			} else {
				// when user hits 'Enter' or clicks 'Search Result' to search
				this.setState({ showResult: true }, () => {
					onActionTrigger(actionType, itemType, { ...data, term });
				});
			}
		} else {
			// when user clicks on any badge component
			onActionTrigger(actionType, itemType, data);
		}
	};

	// store search input in the state
	searchInputChangeHandler = event => {
		this.setState({
			term: event.target.value,
		});
	};

	updateView(nextState) {
		this.setState(nextState);
	}

	render() {
		const { placeholder, showAdvancedSearch, onAdvancedSearchTrigger } =
			this.props;
		const { items, term, showResult, resultCount } = this.state;

		return (
			<div className="common-menu">
				{items.length > 0 &&
					items.map(item => {
						switch (item.type) {
							case ItemType.Search: {
								return (
									<SearchItem
										{...item}
										key={item.id}
										term={term}
										showResult={showResult}
										resultCount={resultCount}
										placeholder={placeholder}
										showAdvancedSearch={showAdvancedSearch}
										onSearchInputChange={this.searchInputChangeHandler}
										onActionTrigger={this.actionHandler}
										onAdvancedSearchTrigger={onAdvancedSearchTrigger}
									/>
								);
							}
							case ItemType.Group: {
								return (
									<GroupItem
										{...item}
										key={item.id}
										onActionTrigger={this.actionHandler}
										onGroupHeaderClick={this.groupHeaderClickHandler}
									/>
								);
							}
							case ItemType.Badge: {
								return (
									<BadgeItem
										{...item}
										key={item.id}
										onActionTrigger={this.actionHandler}
									/>
								);
							}
							default: {
								return null;
							}
						}
					})}
			</div>
		);
	}
}

MenuPanel.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			...BadgeItemPropTypes,

			// needed for Group-type item
			items: PropTypes.arrayOf(PropTypes.shape(BadgeItemPropTypes)),
		})
	).isRequired,
	placeholder: PropTypes.string, // placholder for search input
	showResult: PropTypes.bool,
	resultCount: PropTypes.number,
	onActionTrigger: PropTypes.func,
	showAdvancedSearch: PropTypes.bool,
	onAdvancedSearchTrigger: PropTypes.func,
};
